<template>
    <div>
        <bee-handy-table
            :headers="headers"
            :items="[]"
            dense
            zebra
            hide-default-footer
            :items-per-page="-1"
        ></bee-handy-table>
    </div>
</template>
<script>
export default {
    data() {
        return {
            headers: [
                {
                    text: 'رقم الشريحة',
                    name: '',
                    value: ''
                },
                {
                    text: 'الشهر',
                    name: '',
                    value: ''
                },
                {
                    text: 'السنة',
                    name: '',
                    value: ''
                },
                {
                    text: 'أساس الراتب عند المباشرة بالعمل',
                    name: '',
                    value: ''
                },
                {
                    text: 'أساس الراتب بعد التثبيت',
                    name: '',
                    value: ''
                },
                {
                    text: 'المؤهل العملي',
                    name: '',
                    value: ''
                },
                {
                    text: 'الخبرة العملية',
                    name: '',
                    value: ''
                },
                {
                    text: 'بدل كفاءة',
                    name: '',
                    value: ''
                },
                {
                    text: 'بدل مسؤولية',
                    name: '',
                    value: ''
                },
                {
                    text: 'بدل غلاء معيشي',
                    name: '',
                    value: ''
                },
                {
                    text: 'بدل طعام',
                    name: '',
                    value: ''
                },
                {
                    text: 'بدل سفر',
                    name: '',
                    value: ''
                },
                {
                    text: 'الأقدمية الوظيفية',
                    name: '',
                    value: ''
                }

            ]
        }
    }
}
</script>
